<template>
  <div class="lang-toggle" role="group" aria-label="Language / Langue">
    <button
      type="button"
      class="lang-btn"
      :class="{ active: current === 'fr' }"
      :aria-pressed="current === 'fr'"
      @click="set('fr')"
    >FR</button>
    <span class="sep" aria-hidden="true">|</span>
    <button
      type="button"
      class="lang-btn"
      :class="{ active: current === 'en' }"
      :aria-pressed="current === 'en'"
      @click="set('en')"
    >EN</button>
  </div>
</template>

<script>
import { localeState, setLocale } from '../i18n/index.js'

export default {
  name: 'LanguageToggle',
  computed: {
    current () {
      return localeState.current
    }
  },
  methods: {
    set (loc) {
      setLocale(loc)
    }
  }
}
</script>

<style scoped>
.lang-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.lang-btn {
  background: transparent;
  border: none;
  color: var(--aecom-white);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  opacity: 0.7;
  transition: all 0.2s ease;
}
.lang-btn:hover {
  opacity: 1;
}
.lang-btn.active {
  opacity: 1;
  color: var(--aecom-lime-green);
  text-decoration: underline;
}
.sep {
  color: rgba(255, 255, 255, 0.5);
}
</style>
